import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, bonusesTotalValue } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-blue-50 py-16 md:py-24" data-id="element-17" data-mp="pj6ds81asqsl">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-18" data-mp="avv3sakrleul">
        <header className="mx-auto max-w-narrow text-center" data-id="element-19" data-mp="fu6cuj38jlbr">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-20" data-mp="fsljgwsnq8fh">
            <GiftIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-21" data-mp="5w8n1r5q9gh1" />
            6 bonos, {bonusesTotalValue} en valor
          </h2>
          <p className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-blue-600" data-id="element-22" data-mp="3o3y5xt96h484">
            Hoy gratis con tu compra
          </p>
        </header>

        <ul className="mx-auto mt-12 max-w-3xl divide-y divide-blue-100 overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-blue-100" data-id="element-23" data-mp="1mb1j795wod86">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="flex items-start gap-5 px-5 py-5 md:px-7" data-id="element-24" data-mp="3icvejinyew53" data-mpi={index}>
              <span className="mt-0.5 font-display text-2xl font-extrabold tracking-tight text-blue-200" data-id="element-25" data-mp="3dek5ha5hgpnx">
                0{index + 1}
              </span>
              <div className="min-w-0 flex-1" data-id="element-26" data-mp="3n5eqkb6ztj7s">
                <h3 className="font-display text-lg font-extrabold tracking-tight text-ink" data-id="element-27" data-mp="3n5oii4blm0g4">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-blue-900/75" data-id="element-28" data-mp="2ughbegy2w2j9">{bonus.benefit}</p>
              </div>
              <div className="shrink-0 text-right" data-id="element-29" data-mp="2uitwv431ov12">
                <span className="block text-sm text-blue-900/45 line-through" data-id="element-30" data-mp="38h1tfaw65ubp">{bonus.value}</span>
                <span className="mt-1 inline-block rounded-lg bg-mint-50 px-2.5 py-1 font-display text-xs font-extrabold uppercase tracking-wide text-mint-600" data-id="element-31" data-mp="33ge3ytnl9ljl">
                  Gratis
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}